import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import IntakePage from "./pages/IntakePage";
import CaregiversPage from "./pages/CaregiversPage";
import LegacyAdminPage from "./pages/AdminPage";
import AuthPage from "./pages/AuthPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import { BlogIndexPage, BlogPostPage } from "./pages/BlogPages";
import { ClientHome, ClientNewRequest } from "./pages/ClientPortal";
import { CaregiverHome, CaregiverProfile } from "./pages/CaregiverPortal";
import { AdminDashboard, AdminCases, AdminCaregivers } from "./pages/AdminPortal";
import { AuthProvider } from "./lib/auth";
import { ProtectedRoute } from "./lib/ProtectedRoute";

function App() {
  useEffect(() => {
    document.title =
      "Madison Peaceful Path Home Care | In-Home Senior Care in Madison, WI";
  }, []);

  return (
    <div className="App min-h-screen bg-[#FFFFFF]">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public marketing site */}
            <Route path="/" element={<Home />} />
            <Route path="/intake" element={<IntakePage />} />
            <Route path="/careers" element={<CaregiversPage />} />
            <Route path="/services/:slug" element={<ServiceDetailPage />} />
            <Route path="/blog" element={<BlogIndexPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />

            {/* Auth */}
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/login" element={<Navigate to="/auth" replace />} />

            {/* Client portal */}
            <Route path="/client" element={<ProtectedRoute roles={["client"]}><ClientHome /></ProtectedRoute>} />
            <Route path="/client/new" element={<ProtectedRoute roles={["client"]}><ClientNewRequest /></ProtectedRoute>} />

            {/* Caregiver portal */}
            <Route path="/caregiver" element={<ProtectedRoute roles={["caregiver"]}><CaregiverHome /></ProtectedRoute>} />
            <Route path="/caregiver/profile" element={<ProtectedRoute roles={["caregiver"]}><CaregiverProfile /></ProtectedRoute>} />

            {/* Admin portal (JWT-based ops dashboard) */}
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/cases" element={<ProtectedRoute roles={["admin"]}><AdminCases /></ProtectedRoute>} />
            <Route path="/admin/caregivers" element={<ProtectedRoute roles={["admin"]}><AdminCaregivers /></ProtectedRoute>} />

            {/* Legacy admin (password-based, for the marketing form submissions only) */}
            <Route path="/admin/legacy" element={<LegacyAdminPage />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#005165",
            color: "#FFFFFF",
            border: "1px solid #AC9667",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
